/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1xLhJbx5VveCXJsMYNxtFb
// Component: 8wq_5N080X6o
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/projectcss
import sty from "./PlasmicStepProgressBar.module.css"; // plasmic-import: 8wq_5N080X6o/css

createPlasmicElementProxy;

export const PlasmicStepProgressBar__VariantProps = new Array("statusType");

export const PlasmicStepProgressBar__ArgProps = new Array();

const $$ = {};

function PlasmicStepProgressBar__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "statusType",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.statusType
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root,
        {
          [sty.rootstatusType_completed]: hasVariant(
            $state,
            "statusType",
            "completed"
          ),
          [sty.rootstatusType_currentStep]: hasVariant(
            $state,
            "statusType",
            "currentStep"
          ),
          [sty.rootstatusType_notCompleted]: hasVariant(
            $state,
            "statusType",
            "notCompleted"
          )
        }
      )}
    />
  );
}

const PlasmicDescendants = {
  root: ["root"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicStepProgressBar__ArgProps,
          internalVariantPropNames: PlasmicStepProgressBar__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicStepProgressBar__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicStepProgressBar";
  } else {
    func.displayName = `PlasmicStepProgressBar.${nodeName}`;
  }
  return func;
}

export const PlasmicStepProgressBar = Object.assign(
  // Top-level PlasmicStepProgressBar renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    // Metadata about props expected for PlasmicStepProgressBar
    internalVariantProps: PlasmicStepProgressBar__VariantProps,
    internalArgProps: PlasmicStepProgressBar__ArgProps
  }
);

export default PlasmicStepProgressBar;
/* prettier-ignore-end */
